import { render, staticRenderFns } from "./ShortcutBox.vue?vue&type=template&id=57e347a2"
import script from "./ShortcutBox.vue?vue&type=script&lang=ts"
export * from "./ShortcutBox.vue?vue&type=script&lang=ts"
import style0 from "./ShortcutBox.vue?vue&type=style&index=0&id=57e347a2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ShortcutBox.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports